export interface Address {
  address1: string;
  address2: string;
  city: string;
  state: string;
  country?: string;
  default: boolean;
}
